/// <reference path="../_references.ts"/>

module App.WorkOrder {
	import ServicePlan = App.Appointments.ServicePlan;
	import ServiceableItem = App.ItemManagement.ServiceableItem;
	import Payment = App.Payment.Payment;

	export type Coupon = {

	}

	export class TrixConfig {
		public characterCount: string = '';
		public maxChrs: number = 2000;

		constructor(data? : TrixConfig) {
			const vm = this;
			vm.characterCount = data.characterCount;
			vm.maxChrs = data.maxChrs;
		};
	}

	export type SalesTax = {
		labor_dollar: string;
		labor_percent: string;
		material_dollar: string;
		material_percent: string;
		total: string;
	}

	export type ItemPosition = {
        dirX: number;
        dirY: number;
        distAxX: number;
        distAxY: number;
        distX: number;
        distY: number;
        lastDirX: number;
        lastDirY: number;
        lastX: number;
        lastY: number;
        nowX: number;
        nowY: number;
        offsetX: number;
        offsetY: number;
        startX: number;
        startY: number;
    }

	export type Summary = {
		serviceable_items: ServiceableItem[];
		service_plan: ServicePlan;
		finance_plan: null;
		coupon: Coupon;
		total: string;
		amount_due: string;
		payments: Payment[];
		sales_tax: SalesTax;
		sub_total: string;
		adjustment: {
			discount: string;
			code: string;
		};
		service_plan_discount: string;
	}

	export class Banner {
		public id: number;
		public active: boolean;
		public text: string;
		public color: string;

		constructor(data?: any) {
			if (data) {
				this.active = true;
				this.text = '';
				this.color = '';
			} else {
				this.text = data.text;
				this.active = data.active;
				this.id = data.id;
				this.color = data.color;
			}
		}
	}

	export type Approval = {
		id: number;
		data_url: string;
		print_name: string;
		amount: string;
		created: string;
	}

	export class TermsConditions {
		public id: number;
		public visible: boolean;
		public note: string;
		public name: string;
		public org: number;
		public approved: boolean;

		constructor(data?: TermsConditions) {
			const vm = this;
			data = data || new TermsConditions();
			vm.id = data.id;
			vm.visible = data.visible;
			vm.note = data.note;
			vm.name = data.name;
			vm.org = data.org;
			vm.approved = data.approved;
		}

		isNew() { return +this.id !== +this.id; }

		toJSONString() {
			return JSON.stringify(this);
		}
	}

	export class Template {
		name: string = null;
		favorited: boolean = false;
		shareWithAssoc: boolean = false;
		public: boolean = false;
		upload: boolean = false;

		constructor(data?: Template) {
			if (data) {
				this.name = data.name;
				this.favorited = data.favorited;
				this.shareWithAssoc = data.shareWithAssoc;
				this.public = data.public;
			}

			this.calculateUpload();
		}

		calculateUpload() {
			this.upload = this.public || this.shareWithAssoc;
		}

		reset() {
			this.name = null;
			this.favorited = false;
			this.shareWithAssoc = false;
			this.public = false;
		}
	}
}